// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__205Dh","colMaxWidth":"Table_colMaxWidth__2LUWf"};